<template>
  <div>
    <el-row>
      <organization-breadcrumb :items="[$t('plan_payment.title')]" />
    </el-row>
    <div class="plan-payment">
      <base-text :title="true">
        {{ $t("organizations.plan.plan_title") }}
      </base-text>
      <base-text>
        {{ $t("plan_payment.desc") }}
      </base-text>
      <div v-for="(contract, idx) in payments" :key="idx" class="plan-details">
        <div
          v-if="contract.plan_details[0].is_subscription"
          class="contract-header"
        >
          <el-row>
            <el-col class="left" :span="12">
              <el-row>
                <el-col style="display: flex">
                  <h2>{{ contract.plan }}</h2>
                  <span class="license-info">
                    {{
                      $t("organizations.plan.learners", [
                        contract.plan_details[0].number_of_learner,
                      ])
                    }}
                  </span>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <p>
                    {{
                      $t("organizations.plan.user_month", [
                        formatCurrency(
                          contract.price_per_month,
                          contract.currency
                        ),
                      ])
                    }}
                  </p>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row class="mb-px-8">
                <el-col class="label" :span="12">
                  {{ $t("organizations.plan.redeem_by") }}
                </el-col>
                <el-col class="value" :span="12">
                  {{ formatDate(redeemedBy(contract.date)) }}
                </el-col>
              </el-row>
              <el-row class="mb-px-8">
                <el-col class="label" :span="12">
                  {{ $t("organizations.plan.used") }}
                </el-col>
                <el-col class="value" :span="12">
                  {{
                    $t("organizations.plan.licenses", [
                      contract.plan_details[0].number_of_license_used,
                    ])
                  }}
                </el-col>
              </el-row>
              <el-row
                class="mb-px-8"
                v-if="
                  contract.to_use > 0 &&
                  invalidWarning(
                    contract.date,
                    contract.plan_details[0].package
                  )
                "
              >
                <el-col class="label" style="color: red" :span="12">
                  {{ $t("organizations.plan.expired") }}
                </el-col>
                <el-col
                  class="value"
                  style="color: red; text-decoration: line-through"
                  :span="12"
                >
                  <el-tooltip
                    placement="top"
                    :content="$t('plan_payment.tooltip_invalid_warning')"
                  >
                    <label>
                      {{
                        $t("organizations.plan.contract_to_use_license_s", [
                          contract.to_use,
                        ])
                      }}
                    </label>
                  </el-tooltip>
                </el-col>
              </el-row>
              <el-row
                class="mb-px-8"
                v-else-if="
                  contract.to_use > 0 && warningActivated(contract.date)
                "
              >
                <el-col class="label" style="color: red" :span="12">
                  {{ $t("organizations.plan.to_use") }}
                </el-col>
                <el-col class="value" style="color: red" :span="12">
                  <el-tooltip
                    placement="top"
                    :content="getTooltipWarningActive(contract)"
                  >
                    <label>
                      {{
                        $t("organizations.plan.contract_to_use_license_s", [
                          contract.to_use,
                        ])
                      }}
                    </label>
                  </el-tooltip>
                  <label class="label">
                    {{ $t("organizations.plan.activated") }}
                  </label>
                </el-col>
              </el-row>
              <el-row
                class="mb-px-8"
                v-else-if="
                  contract.to_use > 0 && warningAutoRedeemed(contract.date)
                "
              >
                <el-col class="label" style="color: red" :span="12">
                  {{ $t("organizations.plan.to_use") }}
                </el-col>
                <el-col class="value" style="color: red" :span="12">
                  <el-tooltip
                    placement="top"
                    :content="
                      $t('plan_payment.tooltip_auto_active_warning', [
                        formatDate(redeemedBy(contract.date)),
                      ])
                    "
                  >
                    <label>
                      {{
                        $t("organizations.plan.contract_to_use_license_s", [
                          contract.to_use,
                        ])
                      }}
                    </label>
                  </el-tooltip>
                </el-col>
              </el-row>
              <el-row class="mb-px-8" v-else>
                <el-col class="label" :span="12">
                  {{ $t("organizations.plan.to_use") }}
                </el-col>
                <el-col class="value" :span="12">
                  {{
                    $t("organizations.plan.contract_to_use_license_s", [
                      contract.to_use,
                    ])
                  }}
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <div v-else class="contract-header">
          <el-row>
            <el-col class="left" :span="12">
              <el-row>
                <el-col style="display: flex">
                  <h2>{{ contract.plan }}</h2>
                  <span class="license-info">
                    {{
                      $t("organizations.plan.learners", [
                        contract.plan_details[0].number_of_learner,
                      ])
                    }}
                  </span>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row class="mb-px-8">
                <el-col class="label" :span="12">
                  {{ $t("organizations.plan.used") }}
                </el-col>
                <el-col class="value" :span="12">
                  {{
                    $t("organizations.plan.licenses", [
                      contract.plan_details[0].number_of_license_used,
                    ])
                  }}
                </el-col>
              </el-row>
              <el-row class="mb-px-8">
                <el-col class="label" :span="12">
                  {{ $t("organizations.plan.to_use") }}
                </el-col>
                <el-col class="value" :span="12">
                  {{
                    $t("organizations.plan.contract_to_use_license_s", [
                      contract.to_use,
                    ])
                  }}
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <hr />
        <div
          v-if="contract.plan_details[0].is_subscription"
          class="contract-body"
        >
          <el-row class="mb-px-16">
            <el-col class="label" :span="6">
              {{ $t("organizations.plan.order_id") }}
            </el-col>
            <el-col class="value" :span="6">
              {{ contract.order_id }}
            </el-col>
            <el-col class="label" :span="6">
              {{ $t("organizations.plan.billing_cycle") }}
            </el-col>
            <el-col class="value" :span="6">
              {{ contract.cycle }}
            </el-col>
          </el-row>
          <el-row class="mb-px-16">
            <el-col class="label" :span="6">
              {{ $t("organizations.plan.purchase_date") }}
            </el-col>
            <el-col class="value" :span="6">
              {{ formatDate(contract.date) }}
            </el-col>
            <el-col class="label" :span="6">
              {{ $t("organizations.plan.next_billing_date") }}
            </el-col>
            <el-col class="value" :span="6">
              {{
                contract.plan_details[0].off_auto_renewal
                  ? "--"
                  : formatDate(contract.plan_details[0].next_bill_date)
              }}
            </el-col>
          </el-row>
          <el-row class="mb-px-16">
            <el-col class="label" :span="6">
              {{ $t("organizations.plan.payment_method") }}
            </el-col>
            <el-col class="value" :span="6">
              <label style="text-transform: capitalize">
                {{ contract.payment_method }}
              </label>
            </el-col>
            <el-col class="label" :span="6">
              {{ $t("organizations.plan.next_billing_amount") }}
            </el-col>
            <el-col class="value" :span="6">
              {{
                contract.plan_details[0].off_auto_renewal
                  ? "--"
                  : formatCurrency(
                      contract.plan_details[0].amount,
                      contract.currency
                    )
              }}
            </el-col>
          </el-row>
          <el-row class="mt-px-32" v-if="isActiveOrder(contract.order_id) && !contract.plan_details[0].off_auto_renewal">
            <el-col class="label" :span="12">
              <router-link
                :to="{
                  name: 'OrganizationPaymentDetail',
                  params: {
                    organizationId: organizationId,
                    paymentId: contract.id,
                  },
                }"
                class="el-link el-link--primary"
              >
                <span>
                  {{ $t("organizations.plan.change_payment_details") }}
                </span>
              </router-link>
            </el-col>
            <el-col class="label" :span="12">
              <router-link
                :to="{
                  name: 'OrganizationCancelSubscription',
                  params: {
                    organizationId: organizationId,
                    paymentId: contract.id,
                  },
                }"
                class="el-link el-link--danger"
              >
                <span>
                  {{ $t("organizations.plan.turn_off_auto_renewal") }}
                </span>
              </router-link>
            </el-col>
          </el-row>
        </div>
        <div v-else class="contract-body">
          <el-row class="mb-px-16">
            <el-col class="label" :span="6">
              {{ $t("organizations.plan.order_id") }}
            </el-col>
            <el-col class="value" :span="6">
              {{ contract.order_id }}
            </el-col>
          </el-row>
          <el-row class="mb-px-16">
            <el-col class="label" :span="6">
              {{ $t("organizations.plan.purchase_date") }}
            </el-col>
            <el-col class="value" :span="6">
              {{ formatDate(contract.date) }}
            </el-col>
          </el-row>
          <el-row class="mb-px-16">
            <el-col class="label" :span="6">
              {{ $t("organizations.plan.payment_method") }}
            </el-col>
            <el-col class="value" :span="6">
              {{ contract.payment_method }}
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="buy-more">
        <router-link
          :to="{
            name: 'OrganizationPayment',
            params: { organizationId: organizationId },
          }"
          tag="button"
        >
          {{ $t("organizations.plan.buy_more_packages") }}
        </router-link>
      </div>
      <h2 class="bill-history-title">
        {{ $t("organizations.plan.billing_history") }}
      </h2>
      <table class="billing-history">
        <thead>
          <th>{{ $t("organizations.plan.order_number") }}</th>
          <th>{{ $t("organizations.plan.purchase_date_table_header") }}</th>
          <th>{{ $t("organizations.plan.plan_type") }}</th>
          <th>{{ $t("organizations.plan.amount") }}</th>
          <th>{{ $t("organizations.plan.number_of_licenses") }}</th>
          <th>{{ $t("organizations.plan.transaction_type") }}</th>
        </thead>
        <tbody>
          <tr v-for="(contract, idx) in payments" :key="idx">
            <td>{{ contract.order_id }}</td>
            <td>{{ formatDate(contract.date) }}</td>
            <td>{{ contract.plan_type }}</td>
            <td>
              {{
                formatCurrency(
                  contract.plan_details[0].amount,
                  contract.currency
                )
              }}
            </td>
            <td>
              {{
                $t("organizations.plan.licenses", [
                  contract.plan_details[0].number_of_learner,
                ])
              }}
            </td>
            <td style="text-transform: capitalize">
              {{ contract.transaction_type }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/axios";
import {
  PLAN_MONTH_DURATION,
  WEEK_ALERT_AUTO_REDEEMED,
  WEEK_AUTO_REDEEMED,
  PRODUCT_TYPE_OPTIONS,
  SUBSCRIPTION_PRODUCT_TYPES,
} from "@/constants/generic";
import { currencyLocaleMapping } from "@/helpers/currencies";
import { addMonths, addWeeks, format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import BaseText from "@/components/common/BaseText.vue";
import OrganizationBreadcrumb from "@/components/common/OrganizationBreadcrumb";
import { getPlanLabel } from "@/helpers/functions";

const statusDict = {
  Open: "Unpaid",
  Completed: "Paid",
  Closed: "Paid",
};
const DATE_FORMAT = "MMMM dd, yyyy";
export default {
  components: {
    BaseText,
    OrganizationBreadcrumb,
  },
  props: {
    dateFormat: {
      type: String,
      default: DATE_FORMAT,
    },
  },
  data() {
    return {
      payments: [],
      planDict: {
        one_year_credit: this.$t("organizations.plan.elsa_pro_1_year"),
        six_months_credit: this.$t("organizations.plan.elsa_pro_6_months"),
        three_months_credit: this.$t("organizations.plan.elsa_pro_3_months"),
        one_month_credit: this.$t("organizations.plan.elsa_pro_1_month"),
      },
      planNameSub: {
        one_year_credit: this.$t("organizations.plan.annual"),
        six_months_credit: this.$t("organizations.plan.semi_annual"),
        three_months_credit: this.$t("organizations.plan.quarterly"),
      },
      planTypeNameSub: {
        medium: this.$t("organizations.plan.medium"),
        lite: this.$t("organizations.plan.lite"),
      },
      planCycleDict: {
        one_year_credit: this.$t("organizations.plan.yearly"),
        six_months_credit: this.$t("organizations.plan.every_6_months"),
        three_months_credit: this.$t("organizations.plan.every_3_months"),
        one_month_credit: this.$t("organizations.plan.every_1_month"),
      },
      subProductPrefixLabel: {
        elsa_speak: "PRO",
        premium: "PREMIUM",
      },
      subscriptions: [],
      activeOrders: [],
    };
  },
  computed: {
    organizationId() {
      return this.$store.state.organization.currentOrganizationId;
    },
    organizationData() {
      return this.$store.state.organization.currentOrganization;
    },
    headers() {
      return {
        store: "stripe",
        "x-session-token": localStorage.getItem("payment-token"),
        "x-org-token": Buffer.from(
          `${this.organizationId} ${Date.now()}`
        ).toString("base64"),
      };
    },
  },
  methods: {
    async getPayments() {
      let url = `v1/checkouts/${this.organizationId}/payments`;
      const response = await axios.get(url);
      this.payments = response.data.filter(
        (item) => item.plan_details.length > 0
      );
      for (let i = 0; i < this.payments.length; i++) {
        const element = this.payments[i];
        const plan_details = this.payments[i]["plan_details"][0];
        element["order_id"] = element.id;
        const product_type = plan_details.product_types[0];
        if (plan_details.is_subscription) {
          if (plan_details.title) {
            // store and get plan title from catalog dynamically
            element["plan"] = plan_details.title;
          } else {
            const prefixLabel = this.subProductPrefixLabel[product_type];
            element["plan"] = this.getSubPlanTitleBySetting(plan_details, prefixLabel);
          }
        } else {
          element["plan"] = getPlanLabel(product_type, plan_details.package);
        }
        element["status"] = statusDict[element.status] || element.status;
        element["date"] = element.created_at;
        element["cycle"] = this.planCycleDict[plan_details.package];
        element["plan_type"] = plan_details.is_subscription
          ? this.planNameSub[plan_details.package] + " plan"
          : "non-renewal";
        if(plan_details.is_subscription) {
          element["price_per_month"] =
          plan_details.price_after_discount /
          PLAN_MONTH_DURATION[plan_details.package];
        }
        
        element["to_use"] =
          plan_details.number_of_learner - plan_details.number_of_license_used;
      }
    },
    getSubPlanTitleBySetting(plan_details, prefixLabel) {
      if (plan_details.number_of_learner > 50) {
        return `${prefixLabel} - ${this.planTypeNameSub["medium"]} (${
          this.planNameSub[plan_details.package]
        })`;
      } else {
        return `${prefixLabel} - ${this.planTypeNameSub["lite"]} (${
          this.planNameSub[plan_details.package]
        })`;
      }
    },
    formatDate(date) {
      let timeZone = this.organizationData.timezone;
      if (date) {
        const zonedDate = utcToZonedTime(date, timeZone);
        return format(new Date(zonedDate), this.dateFormat);
      } else {
        return "--";
      }
    },
    redeemedBy(date) {
      return addWeeks(new Date(date), WEEK_AUTO_REDEEMED);
    },
    warningAutoRedeemed(date) {
      const nowTime = new Date().getTime();
      const warningTime = addWeeks(
        new Date(date),
        WEEK_ALERT_AUTO_REDEEMED
      ).getTime();
      return nowTime > warningTime;
    },
    warningActivated(date) {
      const nowTime = new Date().getTime();
      const invalidTime = addWeeks(
        new Date(date),
        WEEK_AUTO_REDEEMED
      ).getTime();
      return nowTime > invalidTime;
    },
    getTooltipWarningActive(contract) {
      const date = this.expiredAtForAutoActive(
        contract.date,
        contract.plan_details[0].package
      );
      return this.$t("plan_payment.tooltip_activated_warning", {
        date: this.formatDate(date),
      });
    },
    invalidWarning(date, membership) {
      const nowTime = new Date().getTime();
      const invalidTime = addMonths(
        addWeeks(new Date(date), WEEK_AUTO_REDEEMED),
        PLAN_MONTH_DURATION[membership]
      ).getTime();
      return nowTime > invalidTime;
    },
    expiredAtForAutoActive(date, membership) {
      const invalidDate = addMonths(
        addWeeks(new Date(date), WEEK_AUTO_REDEEMED),
        PLAN_MONTH_DURATION[membership]
      );
      return invalidDate;
    },
    formatCurrency(price, currency) {
      return new Intl.NumberFormat(currencyLocaleMapping[currency], {
        style: "currency",
        currency: currency,
      }).format(price);
    },
    async getSubscriptions() {
      try {
        const { data } = await this.$axios.get(
          process.env.VUE_APP_PAYMENT_URL + "/organization/subscriptions",
          { headers: this.headers }
        );
        this.subscriptions = data;
        this.activeOrders = data.map((item) => item.order_id);
      } catch (e) {
        e;
      }
    },
    isActiveOrder(orderId) {
      return this.activeOrders.includes(orderId.toString());
    },
  },
  async mounted() {
    const organizationId = this.organizationId;
    if (!this.organizationData) {
      await this.$store.dispatch("organization/getCurrentOrganization", {
        organizationId,
      });
    }
    await Promise.all([this.getPayments(), this.getSubscriptions()]);
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/_colors.scss";
.billing-history {
  width: 100%;
  max-width: 1080px;

  th,
  td {
    border-bottom: 1px solid #ddd;
    padding: 15px;
    text-align: left;
  }

  th {
    font-weight: normal;
  }
  td {
    font-weight: bold;
  }
}
.plan-payment {
  padding-left: 40px;
  padding-top: 32px;

  .title {
    font-weight: 600;
    font-size: 32px;
  }

  .desc {
    font-size: 18px;
  }

  .plan-details {
    border: 1px solid #e6e6e6;
    border-radius: 16px;
    margin-bottom: 24px;
    padding: 24px;
    max-width: 830px;
  }
  .contract-header {
    display: block;
    .right {
      text-align: right;
    }
    .label {
      font-weight: normal;
      font-size: 18px;
      line-height: 24px;
      color: #121131;
      opacity: 0.5;
    }
    .value {
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      color: #121131;
    }
  }
  .contract-body {
    padding-top: 16px;
    .label {
      font-weight: normal;
      font-size: 18px;
      line-height: 24px;
      color: #121131;
    }
    .value {
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      color: #121131;
    }
  }
  .license-info {
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    padding: 6px;
    font-weight: 600;
    margin-left: 15px;
    margin-top: -8px;
  }
}

/*.buymore {
  display: inline-block;
  background: linear-gradient(180deg, #29f4ff -46.11%, #5257ff 151.97%);
  border-radius: 123px;
  border: none;
  color: white;
  padding: 16px;
  font-size: 18px;
}*/
.bill-history-title {
  font-weight: 600;
  font-size: 24px;
  margin-top: 44px;
  margin-bottom: 25px;
}

.buy-more {
  button {
    background: #007eff;
    border-radius: 8px;
    border: none;
    color: #fff;
    padding: 16px;
    font-size: 16px;
    font-weight: 600;
    max-width: 190px;
    cursor: pointer;
  }
}

.el-link {
  font-size: 18px;
  line-height: 24px;

  &--danger {
    color: #eb5757;
  }
}
</style>
